import {
  permissionsRequestsTyped,
  type UpdateUserPermissionsPayload,
} from "@/api/(requests)/permissionsTyped";
import type { UserPermissions, UUID } from "@/core/types";

export async function updateUserPermissions(
  userId: UUID,
  payload: UpdateUserPermissionsPayload,
): Promise<UserPermissions> {
  return permissionsRequestsTyped.update_user_permissions({
    json: payload,
    userId,
  });
}
